import { render, staticRenderFns } from "./ThirdPartyCompanyAssignIssues.vue?vue&type=template&id=209a6ada&scoped=true"
import script from "./ThirdPartyCompanyAssignIssues.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyCompanyAssignIssues.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyCompanyAssignIssues.vue?vue&type=style&index=0&id=209a6ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a6ada",
  null
  
)

export default component.exports